import { HttpRequest, HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { FilePickerAdapter, UploadResponse, UploadStatus, FilePreviewModel } from '@anaidenko/ngx-awesome-uploader';
import { PropertiesService } from 'src/app/services/properties.service';

export class ClientPropertyFilesUploadDialogAdapter extends FilePickerAdapter {
  propertyID!: string;
  userID!: string;

  constructor(private http: HttpClient, private propertiesService: PropertiesService) {
    super();
  }

  public uploadFile(item: FilePreviewModel): Observable<UploadResponse> {
    const propertyID = this.propertyID;
    const userID = this.userID;

    return this.propertiesService.signClientPropertyFileUpload(propertyID, userID, item.fileName, item.file.size, item.file.type).pipe(
      switchMap(res => {
        const headers = new HttpHeaders({
            'Content-Type': String(item.file.type),
            'x-amz-acl':    'public-read',
        });

        const req = new HttpRequest('PUT', res.presignedUrl, item.file, { reportProgress: true, headers });

        return this.http.request(req).pipe(
          switchMap((event: HttpEvent<any>) => {
            if (event.type === HttpEventType.Response) {
              const responseFromBackend = event.body;
              const response: UploadResponse = {
                body: responseFromBackend,
                status: UploadStatus.UPLOADED
              };
              return this.propertiesService.completeClientPropertyFileUpload(propertyID, userID, res.fileID, true).pipe(map(complete => {
                response.body = complete;
                return response;
              }));
            } else if (event.type === HttpEventType.UploadProgress && event.total !== undefined) {
              /** Compute and show the % done: */
              const uploadProgress = event.total > 0 ? +Math.round((100 * event.loaded) / event.total) : 0;
              const response: UploadResponse = {
                status: UploadStatus.IN_PROGRESS,
                progress: uploadProgress
              };
              return of(response);
            } else {
              return of({} as any as UploadResponse);
            }
          }),
          catchError(err => {
            const error: UploadResponse = { status: UploadStatus.ERROR, body: err };
            console.log(error);
            return of(error);
          })
        );
      })
    );
  }

  public removeFile(item: FilePreviewModel): Observable<any> {
    const res = item.uploadResponse;
    const req = res.req;

    if (!res.uploaded) {
        return of(null);
    }

    // console.log('removing file', item);
    return this.propertiesService.deleteClientPropertyFile(req.propertyID, req.fileID);
  }
}
